import request from './axios'

export default {
  // 获取下载链接
  getDownloadLink() {
    return request.get('/api/download')
  }
}